'use client';

import { useState } from 'react';

type Portrait = { url: string; sourceId: string; alt: string } | null;

export function ProfessorPortrait({ portrait, displayName, size = 'card', identityColor = 'var(--ss-brand)' }: { portrait: Portrait; displayName: string; size?: 'compact' | 'card' | 'hero'; identityColor?: string }) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const orderedName = displayName.includes(',') ? displayName.split(',').reverse().join(' ') : displayName;
  const nameParts = orderedName.trim().split(/\s+/).filter(Boolean);
  const initials = [nameParts[0], nameParts.length > 1 ? nameParts.at(-1) : undefined].filter(Boolean).map(part => part!.replace(/[^A-Za-z]/g, '')[0]).join('').toUpperCase() || '?';
  const dimension = size === 'hero' ? 'h-20 w-20 text-xl sm:h-24 sm:w-24 sm:text-2xl' : size === 'compact' ? 'h-6 w-6 text-[9px]' : 'h-11 w-11 text-sm';

  if (!portrait || failedUrl === portrait.url) return <span aria-label={`${displayName} initials`} style={{background:`linear-gradient(135deg, ${identityColor}, color-mix(in srgb, ${identityColor} 60%, var(--ss-info)))`,color:'var(--ss-brand-contrast)'}} className={`inline-flex shrink-0 items-center justify-center rounded-card font-bold ring-2 ring-[var(--ss-surface)] ${dimension}`}>{initials}</span>;

  return <img ref={(element) => {
    // A server-rendered image can fail before React attaches onError.
    if (element?.complete && element.naturalWidth === 0) setFailedUrl(portrait.url);
  }} src={portrait.url} alt={portrait.alt} referrerPolicy="no-referrer" onError={() => setFailedUrl(portrait.url)} className={`shrink-0 rounded-full border-2 border-white object-cover shadow-e1 dark:border-slate-900 ${dimension}`} />;
}
